<template>
  <sidenav-right
    :show="isLog"
    :footer-dialog="true"
    :use-save="false"
    title="Change log"
    @close="closeLog"
  >
    <template v-slot:content>
      <div class="mx-12">
        <el-input
          v-model="searchLog"
          placeholder="Cari"
          class="w-100 m-2"
          @change="searchLogData"
        >
          <template #prefix>
            <el-icon class="el-input__icon">
              <search />
            </el-icon>
          </template>
        </el-input>
      </div>
      <div v-if="!loading">
        <div v-if="!isEmptyLog">
          <el-scrollbar height="80vh" class="mt-14">
            <div v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
              <el-row v-for="item in logs" :key="item.id" class="mx-14 my-12">
                <el-col :span="20">
                  <div class="font-14 font-w-semi-bold color-dark">
                    <div v-if="item.old_url === null">
                      <span>Webhook is active</span>
                    </div>
                    <div v-else-if="item.old_url != item.new_url">
                      <span>URL changed</span>
                    </div>
                    <div v-else-if="item.old_header_request != item.new_header_request">
                      <span>Header changed</span>
                    </div>
                    <div v-else-if="item.old_url !== item.new_url && item.old_header_request !== item.new_header_request">
                      <span>URL & header changed</span>
                    </div>
                  </div>
                  <div class="font-12 color-gray-dark">
                    {{ item.created_at }}
                  </div>
                </el-col>
                <el-col :span="4" class="text-center">
                  <el-icon :size="14" class="mt-20" @click="handleDetail(item)">
                    <arrow-right-bold />
                  </el-icon>
                </el-col>
              </el-row>
            </div>
            <div
              v-if="loadingLog"
              class="flex-container justify-center align-center color-gray-dark"
            >
              <el-icon :size="18">
                <Loading />
              </el-icon>
              <span class="ml-6 font-14">Loading..</span>
            </div>
          </el-scrollbar>
        </div>
        <div v-else>
          <el-row justify="center" class="mx-14">
            <img src="@/assets/icons/bx-empty-webhook.png" height="180" class="mt-32" />
          </el-row>
          <el-row justify="center">
            <div class="font-18 font-w-semi-bold mt-12">
              {{ $t('webhook.no_data') }}
            </div>
          </el-row>
        </div>
      </div>
      <div v-else class="my-24 mx-12">
        <el-skeleton :rows="14" animated />
      </div>
    </template>
  </sidenav-right>
  <webhook-change-detail
    v-model="dialogDetail"
    :detail="detail"
  />
</template>

<script setup>
import { webhookHistory } from '@/api/endpoints/catalog/authOlsera.js'
import { defineProps, defineEmits, onMounted, computed, ref, reactive } from 'vue'
import { Search, ArrowRightBold, Loading } from '@element-plus/icons-vue'
import SidenavRight from '@/components/layout/SidenavRight.vue'
import webhookChangeDetail from './_webhookChangeDetail.vue'

const props = defineProps({
  appId: {
    type: String,
    default: '0',
    required: false
  },
  isLog: {
    required: false
  }
})

const emit = defineEmits(['update:isLog', 'closeLog'])

const loading = ref(false)
const searchLog = ref(null)
const logs = ref([])
const dialogDetail = ref(false)
const detail = ref(null)
const loadingLog = ref(false)
const total = ref(0)
const params = reactive({
  page: 1,
  per_page: 9,
  sort_column: 'id',
  sort_type: 'desc'
})
const noMore = computed(() => logs.value.length >= total.value)
const disabled = computed(() => loadingLog.value || noMore.value)
const isEmptyLog = computed(() => {
  if (logs.value.length <= 0) {
    return true
  }
  return false
})

onMounted(() => {
  getLog()
})

const getLog = () => {
  loading.value = true
  webhookHistory(props.appId, params).then(res => {
    logs.value = res.data.data
    total.value = res.data.meta.total
    loading.value = false
  }).catch(err => {
    console.log(err)
    loading.value = false
  })
}
const closeLog = () => {
  emit('closeLog')
}
const searchLogData = () => {
  params.page = 1
  params.search = searchLog.value
  console.log('search data', searchLog.value)
  getLog()
}
const load = () => {
  loadingLog.value = true
  setTimeout(() => {
    params.page++
    webhookHistory(props.appId, params).then(res => {
      loadingLog.value = false
      res.data.data.forEach(item => logs.value.push(item))
    }).catch(err => {
      console.log(err)
    })
  }, 1000)
}
const handleDetail = (params) => {
  console.log('detail', params)
  dialogDetail.value = true
  const data = [{
    title: 'Activity',
    value: 'URL changed'
  }, {
    title: 'Date',
    value: params.created_at
  }, {
    title: 'Previous',
    value: params.old_url
  }, {
    title: 'New',
    value: params.new_url
  }, {
    title: 'Request header',
    value: JSON.stringify(params.new_header_request, null, 4)
  }, {
    title: 'Response',
    value: null
  }]
  detail.value = data
}
</script>
